/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum DomainReportDocTypeString {
    "ReportDocTypeActStr" = "act",
    "ReportDocTypeAgentReportStr" = "agentreport",
    "ReportDocTypeInvoiceStr" = "invoice"
}